import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { RegistrationCreditCheck } from "./registrationCreditCheck"
import { IRegistrationCreditCheck } from "./registrationCreditCheck.types"
import { safeDayjs } from "@/helpers/dateHelper"
import dayjs from "dayjs"

export interface IRegistrationCreditCheckRaw {
  id: number
  status: string
  first_name: string
  last_name: string
  account_number: string
  billing_account_id: number
  deposit_deadline_dt: string
  deposit_paid_dt: string
  date_of_birth: string
  created_dt?: string
  registration_credit_check_registraion_credit_check_address: AddressRaw[]
  registration_credit_check_billing_account?: BillingAccountRaw
  deposit_amount: number | null
}

interface AddressRaw {
  street1?: string
  postcode: string
  is_supply_address: boolean
  billing_account_id: number
}

interface CustomerContactRaw {
  primary: boolean
  contact: {
    email: string
  }
}

interface CustomerRaw {
  number?: string
  customer_contacts: CustomerContactRaw[]
}

export interface BillingAccountRaw {
  id: number
  deleted: string | null
  closed: string | null
  cancelled: string | null
  terminated: string | null
  to_date: string | null
  customer: CustomerRaw
}

export const RegistrationCreditCheckParser: IParser<
  IRegistrationCreditCheck,
  IRegistrationCreditCheckRaw
> = {
  toDomain: (data: IRegistrationCreditCheckRaw) => {
    try {
      const billingAccount = data.registration_credit_check_billing_account

      const supplyAddress =
        data.registration_credit_check_registraion_credit_check_address?.filter(
          (address) => {
            return address.is_supply_address
          },
        )[0] ?? {}

      const isAccountActive =
        billingAccount?.terminated === null &&
        billingAccount?.closed === null &&
        billingAccount?.cancelled === null &&
        billingAccount?.deleted === null &&
        (billingAccount.to_date === null ||
          safeDayjs(billingAccount.to_date)?.isAfter(dayjs(), "day") === true)

      const primaryContact =
        billingAccount?.customer?.customer_contacts?.filter((contact) => {
          return contact.primary
        })[0].contact

      return new RegistrationCreditCheck({
        id: data.id,
        status: data.status,
        firstName: data.first_name,
        lastName: data.last_name,
        accountNumber: data.account_number,
        billingAccountId: data.billing_account_id,
        depositDeadline: safeDayjs(data.deposit_deadline_dt),
        depositPaid: safeDayjs(data.deposit_paid_dt),
        dateOfBirth: data.date_of_birth,
        isAccountActive: isAccountActive,
        addressLine1: supplyAddress?.street1 ?? "",
        postCode: supplyAddress.postcode,
        createdAt: safeDayjs(data.created_dt),
        amount: data.deposit_amount,
        email: primaryContact?.email ?? "",
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
} as IParser<IRegistrationCreditCheck, IRegistrationCreditCheckRaw>
